/**
 * Connection Status Value Object
 */
export enum ConnectionStatus {
    DISCONNECTED = 'DISCONNECTED',
    CONNECTING = 'CONNECTING',
    CONNECTED = 'CONNECTED',
    RECONNECTING = 'RECONNECTING',
    ERROR = 'ERROR',
}

export class ChatConnectionStatus {
    private constructor(private readonly _status: ConnectionStatus) { }

    static create(status: ConnectionStatus): ChatConnectionStatus {
        return new ChatConnectionStatus(status);
    }

    static disconnected(): ChatConnectionStatus {
        return new ChatConnectionStatus(ConnectionStatus.DISCONNECTED);
    }

    static connecting(): ChatConnectionStatus {
        return new ChatConnectionStatus(ConnectionStatus.CONNECTING);
    }

    static connected(): ChatConnectionStatus {
        return new ChatConnectionStatus(ConnectionStatus.CONNECTED);
    }

    static reconnecting(): ChatConnectionStatus {
        return new ChatConnectionStatus(ConnectionStatus.RECONNECTING);
    }

    static error(): ChatConnectionStatus {
        return new ChatConnectionStatus(ConnectionStatus.ERROR);
    }

    get status(): ConnectionStatus {
        return this._status;
    }

    get isConnected(): boolean {
        return this._status === ConnectionStatus.CONNECTED;
    }

    get isDisconnected(): boolean {
        return this._status === ConnectionStatus.DISCONNECTED;
    }

    get isConnecting(): boolean {
        return this._status === ConnectionStatus.CONNECTING || this._status === ConnectionStatus.RECONNECTING;
    }

    get hasError(): boolean {
        return this._status === ConnectionStatus.ERROR;
    }
}
